<template>
  <div class="fapq-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <div class="card-title">
            建店立项
            <div class="search-mode">
              <input type="text" class="search-input" @keyup.enter="Search" placeholder="关键字搜索" v-model="search" />
              <el-button class="search-btn" icon="el-icon-search" @click="Search"/>
            </div>
          </div>
          <div class="card-content" >
            <el-row>
              <el-col :span="5">
                <ul class="group-filter">
                  <li :class="type===0?'active':''" @click="change(0)">未立项</li>
                  <li :class="type===1?'active':''" @click="change(1)">已立项</li>
                </ul>
              </el-col>
              <el-col :span="19" v-loading="loading">
                <el-table
                  :data="tableData"
                  :show-header="false"
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="客户名称"
                    width="180"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="type===0" type="danger">待立项</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="type===1">已立项</el-tag>
                      <span style="color:#000;margin-left: 6px;">{{scope.row.all_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="签订时间"
                    width="220"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">签订时间：</span>
                      <span> {{scope.row.sign_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="代理品牌"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">代理品牌：</span>
                      <span> {{scope.row.brands}}</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="方案排期详情"
      :visible.sync="editVisible"
      top="6vh"
      width="30%">
      <div v-loading="dloading">
        <el-form ref="editForm" :model="editForm" :rules="editRules"  label-position="right" label-width="auto" size="small">
          <el-form-item label="客户全称" prop="delname">
            <el-input
              v-model="editForm.delname"
              :disabled="true">
            </el-input>
          </el-form-item>
          <el-form-item label="起始时间" prop="starttime">
            <el-date-picker
              v-model="editForm.starttime"
              type="date"
              style="width: 100%"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              @change="setTime"
              :disabled="startdis"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <div v-for="(item, index) in editForm.planInfo" :key="item.key">
            <el-form-item :label="item.name" :prop="'planInfo.' + index +'.val'" :rules="planInfoRules.val">
              <el-input-number
                @change="setTime"
                :min="1"
                :disabled="item.mark===1"
                v-model="item.val">
              </el-input-number>
              <span style="color:#99a9bf;font-size:12px;margin-left: 10px">标准工期 {{item.day}} 天</span>
            </el-form-item>
          </div>
          <el-form-item label="验收时间" prop="endtime">
            <el-date-picker
              v-model="editForm.endtime"
              :disabled="true"
              type="date"
              style="width: 100%"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              placeholder="根据工期自动计算">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="editLoading" @click="submitForm('editForm')">立即提交</el-button>
        <el-button size="small" @click="editVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择模板"
      :visible.sync="modeVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="true"
      :append-to-body="true">
      <div class="model-list">
        <div class="model-item" @click="editProject">
          <div class="add-icon"><i class="el-icon-plus"></i></div>
          <div class="add-txt">空白项目</div>
        </div>
        <div v-for="m in templateData" class="model-item project-model" :style="`background-image: url(${project_model_bg})`">
          <div class="txt">{{m.temname}}</div>
          <div class="btn">
            <el-button size="mini" @click="previewModel(m)">预览</el-button>
            <el-button size="mini" @click="useModel(m)" type="primary" style="margin-left: 0">使用</el-button>
          </div>
        </div>
        <div class="model-item project-model" :style="`background-image: url(${project_model_bg})`"  v-if="user.dGroupid === 1" >
          <div class="txt">首造建店</div>
          <div class="btn">
            <el-button size="mini" @click="szEditProject" type="primary" style="margin-left: 0">使用</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="模板预览"
      :visible.sync="previewVisible"
      width="50%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="true"
      :append-to-body="true">
      <div style="font-weight: 400;font-size: 22px;color:#1f2f3d;margin: 20px 0 20px;">{{changeModel.temname}}</div>
      <div style="font-size: 14px;color: #5e6d82;margin-bottom: 20px">{{changeModel.explain}}</div>
      <el-steps style="margin-bottom: 20px" simple>
        <el-step title="未开始"></el-step>
        <el-step v-for="s in changeModel.stagelist" :title="s.stagename"></el-step>
        <el-step title="已完成"></el-step>
      </el-steps>
      <div class="task-main">
        <div class="task-box" :style="`width: ${tasklevel*220}px`">
          <div class="task-level" v-for="l in tasklevel">
            <div v-for="t in changeTaskList" :class="t.isgreen?'task task-green':'task'" @mouseover="showModelGreen(t)" @mouseleave="hideModelGreen(t)" v-if="t.level===l">
              <div class="task-header">
                <div class="xh">{{t.xh}}</div>
                <span>{{t.name}}</span>
              </div>
              <div class="task-foot" v-if="t.level>1">
                <div class="tit" style="padding-top: 10px;">前提条件：</div>
                <div class="c" v-for="q in t.opencond">
                  <span v-for="t1 in changeTaskList" v-if="t1.id===q">{{t1.xh}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="useModel(changeModel)">使用此模板</el-button>
        <el-button size="small" @click="previewVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="建店立项"
      :visible.sync="editInfoVisible"
      width="70%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="false"
      :append-to-body="true">
      <el-form ref="eForm" :model="eForm"  :rules="eFormRules" label-position="right" label-width="80px" size="small">
        <el-form-item label="项目名称" prop="name">
          <el-input v-model="eForm.name" clearable maxlength="100" style="width: 100%" show-word-limit />
        </el-form-item>
        <el-form-item label="项目说明" prop="explain">
          <el-input
            style="width: 100%"
            v-model="eForm.explain"
            maxlength="300"
            type="textarea"
            :rows="2"
            clearable
            show-word-limit/>
        </el-form-item>
        <el-form-item label="项目状态" prop="mark">
          <el-radio-group v-model="eForm.mark">
            <el-radio :label="0">未开始</el-radio>
            <el-radio :label="1">进行中</el-radio>
            <el-radio :label="2">已暂停</el-radio>
            <el-radio :label="3">已完成</el-radio>
            <el-radio :label="4">已取消</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="项目周期" prop="time">
          <el-date-picker
            v-model="eForm.time"
            size="mini"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="截止日期"
            :clearable="false"
            type="daterange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目阶段" prop="stage">
          <el-tag type="info">未开始</el-tag>
          <el-tag
            :key="tag"
            v-for="tag in eForm.flowStageList"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            maxlength="20"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加阶段</el-button>
          <el-tag type="info">已完成</el-tag>
        </el-form-item>
        <el-form-item label="项目事项" prop="task">
          <span style="color:#99a9bf;font-size: 12px"><i class="el-icon-info"></i> 有前提条件的事项必须在前提条件所有事项完成后才可产生</span>
          <div class="task-main">
            <div class="task-box" :style="`width: ${tasklevel*220}px`">
              <div class="task-level" v-for="l in tasklevel">
                <div v-for="t in eForm.taskList" :class="t.isgreen?'task task-green':'task'" @mouseover="showGreen(t)" @mouseleave="hideGreen(t)" v-if="t.level===l">
                  <div class="task-header">
                    <div class="xh">{{t.xh}}</div>
                    <span>{{t.name}}</span>
                    <div class="edit" @click="editTask(t)"><i class="el-icon-edit-outline"></i></div>
                    <div class="close" @click="delTask(t)"><i class="el-icon-close"></i></div>
                  </div>
                  <div class="task-foot" v-if="t.level>1">
                    <div class="tit">前提条件：</div>
                    <div class="c" v-for="q in t.opencond">
                      <span v-for="t1 in eForm.taskList" v-if="t1.id===q">{{t1.xh}}</span>
                    </div>
                  </div>
                </div>
                <div class="add-task" @click="addTask(l)"><i class="el-icon-plus"></i> 添加事项</div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button  type="primary" size="small" :loading="subLoading" @click="createOrEditTemplate('eForm')">立即提交</el-button>
        <el-button size="small" @click="editInfoVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="首造建店"
      :visible.sync="szEditInfoVisible"
      width="70%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="false"
      :append-to-body="true">
      <el-form ref="szForm" :model="szForm"  :rules="szFormRules" label-position="right" label-width="80px" size="small">
        <el-form-item label="项目名称" prop="name">
          <el-input v-model="szForm.name" clearable maxlength="20" style="width: 100%" show-word-limit />
        </el-form-item>
        <el-form-item label="项目说明" prop="remark">
          <el-input
            style="width: 100%"
            v-model="szForm.remark"
            maxlength="100"
            type="textarea"
            :rows="2"
            clearable
            show-word-limit/>
        </el-form-item>
        <el-form-item label="平面周期" prop="pmtime">
          <el-date-picker
            v-model="szForm.pmtime"
            size="mini"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="截止日期"
            :clearable="false"
            type="daterange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="效果周期" prop="xgtime">
          <el-date-picker
            v-model="szForm.xgtime"
            size="mini"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="截止日期"
            :clearable="false"
            type="daterange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="施工周期" prop="sgtime">
          <el-date-picker
            v-model="szForm.sgtime"
            size="mini"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="截止日期"
            :clearable="false"
            type="daterange">
          </el-date-picker>
        </el-form-item>


        <el-form-item label="施工交底" prop="sgjdtime">
          <el-date-picker
            v-model="szForm.sgjdtime"
            size="mini"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="截止日期"
            :clearable="false"
            type="daterange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="复尺周期" prop="fctime">
          <el-date-picker
            v-model="szForm.fctime"
            size="mini"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="截止日期"
            :clearable="false"
            type="daterange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="深化图纸" prop="shtztime">
          <el-date-picker
            v-model="szForm.shtztime"
            size="mini"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="截止日期"
            :clearable="false"
            type="daterange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="下单周期" prop="xdtime">
          <el-date-picker
            v-model="szForm.xdtime"
            size="mini"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="截止日期"
            :clearable="false"
            type="daterange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="验收周期" prop="ystime">
          <el-date-picker
            v-model="szForm.ystime"
            size="mini"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="截止日期"
            :clearable="false"
            type="daterange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="预计开业" prop="opentime">
          <el-date-picker
            v-model="szForm.opentime"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            type="date">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button  type="primary" size="small" :loading="szSubLoading" @click="szCreateOrEditShop('szForm')">立即提交</el-button>
        <el-button size="small" @click="szEditInfoVisible = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="editTaskTitle"
      :visible.sync="editTaskVisible"
      width="400px"
      :destroy-on-close="true"
      :lock-scroll="true"
      :close-on-click-modal="true"
      :append-to-body="true">
      <el-form ref="taskForm" :model="taskForm"  :rules="taskFormRules" label-position="right" label-width="80px" size="small">
        <el-form-item label="前提条件" prop="opencond" v-if="taskForm.level>1">
          <el-select v-model="taskForm.opencond" multiple placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in opencondOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事项名称" prop="name">
          <el-input v-model="taskForm.name" clearable maxlength="100" style="width: 100%" show-word-limit />
        </el-form-item>
        <el-form-item label="事项说明" prop="remark">
          <el-input
            v-model="taskForm.remark"
            maxlength="300"
            type="textarea"
            :rows="2"
            clearable
            show-word-limit/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button  type="primary" size="small" @click="subTask">确定</el-button>
        <el-button size="small" @click="editTaskVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getProgramSchedule,
  getPlanStageList,
  szCreateOrEditShop,
  addOrEditProgramSchedule,
  selectTemplateData, createOrEditProject
} from '@/api/work'
import project_model_bg from '@/assets/project_model_bg.jpg'
import { guid } from '@/utils'
import qs from 'qs'
export default {
  name: 'fapq',
  computed: {
    user: getUser,
    pickerOptions() {
      var _this = this
      return {
        disabledDate(time) {
          let str = _this.sign_time.replace(/[^\d]/g, '/')
          return time.getTime() < new Date(str)
        }
      }
    }
  },
  data() {
    const validateStage = (rule, value, callback) => {
      if (this.eForm.flowStageList.length <= 0) {
        callback(new Error('至少添加一个阶段'))
      } else {
        callback()
      }
    }
    const validateTask = (rule, value, callback) => {
      if (this.eForm.taskList.length <= 0) {
        callback(new Error('至少添加一个事项'))
      } else {
        callback()
      }
    }
    const validateOpencond = (rule, value, callback) => {
      if (this.taskForm.opencond.length <= 0) {
        callback(new Error('至少选择一个前提条件'))
      } else {
        callback()
      }
    }
    return {
      modeVisible: false,
      project_model_bg: project_model_bg,
      templateData: [],
      search: '',
      type: 0,
      loading: false,
      dloading: false,
      editLoading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      sign_time: '',
      planStage: [],
      startdis: false,
      editForm: {
        exid: null,
        delname: '',
        starttime: '',
        endtime: '',
        planInfo: []
      },
      editRules: {
        starttime: [{ required: true, message: '请选择起始时间', trigger: 'change' }],
        endtime: [{ required: true, message: '请选择验收时间', trigger: 'change' }],
        delname: [{ required: true, message: '请选择客户', trigger: 'blur' }]
      },
      planInfoRules: {
        val: [{ required: true, message: '请输入工期天数', trigger: 'blur' }]
      },
      currentdelid: null,
      currentdelname: '',
      changeModel: {},
      changeTaskList: [],
      tasklevel: 1,
      previewVisible: false,
      eForm: {
        pid: null,
        name: null,
        explain: null,
        time: [],
        mark: 0,
        flowStageList: [],
        taskList: []
      },
      eFormRules: {
        name: [{ required: true, message: '项目名称不能为空', trigger: 'blur' }],
        mark: [{ required: true, message: '项目状态不能为空', trigger: 'change' }],
        time: [{ required: true, message: '项目周期不能为空', trigger: 'change' }],
        stage: [{ required: true, trigger: 'change', validator: validateStage }],
        task: [{ required: true, trigger: 'change', validator: validateTask }]
      },
      editInfoVisible: false,
      inputVisible: false,
      inputValue: '',
      subLoading: false,
      taskForm: {
        xh: 0,
        id: '',
        name: '',
        remark: '',
        level: 0,
        opencond: []
      },
      taskFormRules: {
        name: [{ required: true, message: '事项名称不能为空', trigger: 'blur' }],
        opencond: [{ required: true, trigger: 'change', validator: validateOpencond }]
      },
      editTaskTitle: '',
      editTaskVisible: false,
      opencondOptions: [],
      szEditInfoVisible: false,
      szSubLoading: false,
      szForm: {
        ex_id: null,
        sid: null,
        userid: null,
        groupid: null,
        name: '',
        remark: '',
        opentime: '',
        pmtime: [],
        xgtime: [],
        sgtime: [],
        sgjdtime: [],
        fctime: [],
        shtztime: [],
        xdtime: [],
        ystime: []
      },
      szFormRules: {
        name: [{ required: true, message: '项目名称不能为空', trigger: 'blur' }],
        pmtime: [{ required: true, message: '平面周期不能为空', trigger: 'change' }],
        xgtime: [{ required: true, message: '效果周期不能为空', trigger: 'change' }],
        sgtime: [{ required: true, message: '施工周期不能为空', trigger: 'change' }],
        opentime: [{ required: true, message: '预计开业不能为空', trigger: 'change' }],
        sgjdtime: [{ required: true, message: '施工交底周期不能为空', trigger: 'change' }],
        fctime: [{ required: true, message: '复尺周期不能为空', trigger: 'change' }],
        shtztime: [{ required: true, message: '深化图纸周期不能为空', trigger: 'change' }],
        xdtime: [{ required: true, message: '下单周期不能为空', trigger: 'change' }],
        ystime: [{ required: true, message: '验收周期不能为空', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getData()
    this.getTemplate()
  },
  methods: {
    szEditProject() {
      this.szEditInfoVisible = true
      this.szForm.sid = null
      this.szForm.remark = null
      this.szForm.name = ''
      this.szForm.opentime = ''
      this.szForm.pmtime = []
      this.szForm.xgtime = []
      this.szForm.sgtime = []
      this.szForm.sgjdtime = []
      this.szForm.fctime = []
      this.szForm.shtztime = []
      this.szForm.xdtime = []
      this.szForm.ystime = []
    },
    szCreateOrEditShop(fromName) {
      this.$refs[fromName].validate((valid) => {
        if (valid) {
          if (!this.szSubLoading) {
            this.szSubLoading = true
            const data = {
              ex_id: this.szForm.ex_id,
              sid: this.szForm.sid,
              userid: this.user.dUserid,
              name: this.szForm.name,
              remark: this.szForm.remark,
              groupid: this.user.dGroupid,
              opentime: this.szForm.opentime,
              pmStarttime: this.szForm.pmtime[0],
              pmEndtime: this.szForm.pmtime[1],
              xgStarttime: this.szForm.pmtime[0],
              xgEndtime: this.szForm.pmtime[1],
              sgStarttime: this.szForm.pmtime[0],
              sgEndtime: this.szForm.pmtime[1],
              sgjdStarttime: this.szForm.sgjdtime[0],
              sgjdEndtime: this.szForm.sgjdtime[1],
              fcStarttime: this.szForm.fctime[0],
              fcEndtime: this.szForm.fctime[1],
              shtzStarttime: this.szForm.shtztime[0],
              shtzEndtime: this.szForm.shtztime[1],
              xdStarttime: this.szForm.xdtime[0],
              xdEndtime: this.szForm.xdtime[1],
              ysStarttime: this.szForm.ystime[0],
              ysEndtime: this.szForm.ystime[1]
            }
            szCreateOrEditShop(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.currentdelid = null
              this.currentdelname = ''
              this.szEditInfoVisible = false
              this.szSubLoading = false
              this.modeVisible = false
              this.getData()
            }).catch(() => {
              this.szSubLoading = false
            })
          }
        }
      })
    },
    createOrEditTemplate(fromName) {
      this.$refs[fromName].validate((valid) => {
        if (valid) {
          if (!this.subLoading) {
            this.subLoading = true
            const data = {
              pid: this.eForm.pid,
              name: this.eForm.name,
              explain: this.eForm.explain,
              userid: this.user.dUserid,
              groupid: this.user.dGroupid,
              startdate: this.eForm.time[0],
              enddate: this.eForm.time[1],
              mark: this.eForm.mark,
              flowStageList: qs.parse(this.eForm.flowStageList),
              taskList: qs.parse(this.eForm.taskList),
              delid: this.currentdelid
            }
            createOrEditProject(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.currentdelid = null
              this.currentdelname = ''
              this.editInfoVisible = false
              this.subLoading = false
              this.getData()
            }).catch(() => {
              this.subLoading = false
            })
          }
        }
      })
    },
    delTask(t) {
      let isok = true
      for (const te of this.eForm.taskList) {
        for (const o of te.opencond) {
          if (o === t.id) {
            isok = false
            break
          }
        }
        if (!isok) {
          break
        }
      }
      if (isok) {
        this.$confirm('您确定要删除此事项吗?', '删除事项', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.eForm.taskList.splice(this.eForm.taskList.indexOf(t), 1)
          let _tasklevel = 1
          for (const t of this.eForm.taskList) {
            if (t.level > _tasklevel) {
              _tasklevel = t.level
            }
          }
          this.tasklevel = _tasklevel + 1
        })
      } else {
        this.$message({
          type: 'error',
          message: '该事项已是其他事项的前提条件'
        })
      }
    },
    subTask() {
      this.$refs['taskForm'].validate((valid) => {
        if (valid) {
          if (this.editTaskTitle === '编辑事项') {
            for (let t of this.eForm.taskList) {
              if (t.xh === this.taskForm.xh && t.id === this.taskForm.id) {
                t.name = this.taskForm.name
                t.remark = this.taskForm.remark
                t.opencond = this.taskForm.opencond
              }
            }
          } else {
            this.eForm.taskList.push({
              xh: this.taskForm.xh,
              id: this.taskForm.id,
              name: this.taskForm.name,
              remark: this.taskForm.remark,
              level: this.taskForm.level,
              opencond: this.taskForm.opencond,
              isgreen: false
            })
            let _tasklevel = 1
            for (const t of this.eForm.taskList) {
              if (t.level > _tasklevel) {
                _tasklevel = t.level
              }
            }
            this.tasklevel = _tasklevel + 1
          }
          this.editTaskVisible = false
        }
      })
    },
    addTask(n) {
      this.taskForm.id = guid()
      let xh = 1
      if (this.eForm.taskList.length > 0) {
        xh = this.eForm.taskList[this.eForm.taskList.length - 1].xh + 1
      }
      this.taskForm.xh = xh
      this.taskForm.name = ''
      this.taskForm.remark = ''
      this.taskForm.opencond = []
      this.taskForm.level = n
      if (this.taskForm.level > 1) {
        let _opencondOptions = []
        for (const t of this.eForm.taskList) {
          if (t.level === this.taskForm.level - 1) {
            _opencondOptions.push({ id: t.id, name: t.name })
          }
        }
        this.opencondOptions = _opencondOptions
      } else {
        this.opencondOptions = []
      }
      this.editTaskTitle = '添加事项'
      this.editTaskVisible = true
    },
    editTask(t) {
      this.taskForm = {
        xh: t.xh,
        id: t.id,
        name: t.name,
        remark: t.remark,
        level: t.level,
        opencond: t.opencond
      }
      if (this.taskForm.level > 1) {
        let _opencondOptions = []
        for (const t of this.eForm.taskList) {
          if (t.level === this.taskForm.level - 1) {
            _opencondOptions.push({ id: t.id, name: t.name })
          }
        }
        this.opencondOptions = _opencondOptions
      } else {
        this.opencondOptions = []
      }
      this.editTaskTitle = '编辑事项'
      this.editTaskVisible = true
    },
    useModel(m) {
      this.modeVisible = false
      this.previewVisible = false
      this.eForm.pid = 0
      this.eForm.name = `${this.currentdelname} 建店进展`
      this.eForm.explain = null
      this.eForm.time = []
      this.eForm.mark = 0
      let _flowStageList = []
      for (const stage of m.stagelist) {
        _flowStageList.push(stage.stagename)
      }
      this.eForm.flowStageList = _flowStageList
      let _taskList = []
      let xh = 1
      for (const task of m.tasklist) {
        _taskList.push({
          xh: xh,
          id: guid(),
          name: task.taskname,
          remark: task.remark,
          level: task.level,
          opencond: task.opencond.split(','),
          oldid: task.stid,
          isgreen: false
        })
        xh++
      }
      for (let t of _taskList) {
        if (t.opencond.length > 0) {
          let _opencond = []
          for (const o of t.opencond) {
            for (const te of _taskList) {
              if (te.oldid === o) {
                _opencond.push(te.id)
                break
              }
            }
          }
          t.opencond = _opencond
        }
      }
      this.eForm.taskList = _taskList
      let _tasklevel = 1
      for (const t of this.eForm.taskList) {
        if (t.level > _tasklevel) {
          _tasklevel = t.level
        }
      }
      this.tasklevel = _tasklevel + 1
      this.editInfoVisible = true
    },
    showGreen(t) {
      for (const o of t.opencond) {
        for (let te of this.eForm.taskList) {
          if (o === te.id) {
            te.isgreen = true
          }
        }
      }
    },
    hideGreen(t) {
      for (const o of t.opencond) {
        for (let te of this.eForm.taskList) {
          if (o === te.id) {
            te.isgreen = false
          }
        }
      }
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        this.eForm.flowStageList.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    handleClose(tag) {
      this.eForm.flowStageList.splice(this.eForm.flowStageList.indexOf(tag), 1)
    },
    editProject() {
      this.modeVisible = false
      this.previewVisible = false
      this.eForm.pid = 0
      this.eForm.name = `${this.currentdelname} 建店进展`
      this.eForm.explain = null
      this.eForm.time = []
      this.eForm.mark = 0
      this.eForm.flowStageList = ['进行中']
      this.eForm.taskList = []
      this.tasklevel = 1
      this.editInfoVisible = true
    },
    showModelGreen(t) {
      for (const o of t.opencond) {
        for (let te of this.changeTaskList) {
          if (o === te.id) {
            te.isgreen = true
          }
        }
      }
    },
    hideModelGreen(t) {
      for (const o of t.opencond) {
        for (let te of this.changeTaskList) {
          if (o === te.id) {
            te.isgreen = false
          }
        }
      }
    },
    previewModel(m) {
      this.changeModel = m
      let _taskList = []
      let xh = 1
      for (const task of m.tasklist) {
        _taskList.push({
          xh: xh,
          id: task.stid,
          name: task.taskname,
          remark: task.remark,
          level: task.level,
          opencond: task.opencond.split(','),
          isgreen: false
        })
        xh++
      }
      this.changeTaskList = _taskList
      let _tasklevel = 1
      for (const t of this.changeTaskList) {
        if (t.level > _tasklevel) {
          _tasklevel = t.level
        }
      }
      this.tasklevel = _tasklevel
      this.previewVisible = true
    },
    getTemplate() {
      const data = {
        groupid: this.user.dGroupid,
        page: 1,
        limit: 999999
      }
      selectTemplateData(data).then(response => {
        this.templateData = response.data
      })
    },
    getPlanStage() {
      getPlanStageList().then(response => {
        this.planStage = response.data
      }).catch(() => {})
    },
    setTime() {
      if (this.editForm.starttime != null && this.editForm.starttime!='') {
        let allday = 0
        for (let plan of this.editForm.planInfo) {
          if (plan.val !== undefined) {
            allday += parseInt(plan.val)
          }
        }
        let d = new Date(this.editForm.starttime)
        d.setDate(d.getDate() + allday)
        let m = d.getMonth() + 1
        m = m < 10 ? '0' + m : '' + m
        let dd = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
        this.editForm.endtime = d.getFullYear() + '-' + m + '-' + dd
      } else {
        this.editForm.endtime = ''
      }
    },
    change(n) {
      if (this.type === n) {
        return false
      }
      this.type = n
      this.getData()
    },
    Search() {
      if (this.search != null && this.search.trim() != '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        type: this.type,
        content: this.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid
      }
      getProgramSchedule(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      if (this.type === 0) {
        this.currentdelid = row.delid
        this.currentdelname = row.all_name
        this.szForm.ex_id = row.ex_id
        this.modeVisible = true
      } else {
        if (row.sid !== null && row.sid !== undefined && row.sid !== '' && row.sid !== 0) {
          this.$router.push({
            path: `/work/szjd/${row.sid}`
          })
        } else {
          if (row.pid !== null && row.pid !== undefined && row.pid !== '' && row.pid !== 0) {
            this.$router.push({ path: '/work/project_detail/' + row.pid })
          } else {
            this.$message.error('无此关联的项目')
          }
        }
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editLoading) {
            this.editLoading = true
            let jsonStr = ''
            for (let p of this.editForm.planInfo) {
              jsonStr += '"' + p.psid + '":"' + p.val + '",'
            }
            if (jsonStr.length > 0) {
              jsonStr = '{' + jsonStr.substring(0, jsonStr.length - 1) + '}'
            }
            const data = {
              exid: this.editForm.exid,
              starttime: this.editForm.starttime,
              endtime: this.editForm.endtime,
              type: this.type,
              jsonStr: jsonStr,
              userid: this.user.dUserid
            }
            addOrEditProgramSchedule(data).then(response => {
              this.$message({
                message: '方案排期提交成功',
                type: 'success'
              })
              this.editLoading = false
              this.editVisible = false
              this.getData()
            }).catch(() => {
              this.editLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fapq-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
.model-list{
  width: 100%;
  position: relative;
  padding-bottom: 20px;
  &:after{
    clear: both;
    display: table;
    content: '';
  }
  .model-item{
    width: 150px;
    float: left;
    height: 100px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    cursor: pointer;
    font-size: 12px;
    margin-bottom: 20px;
    margin-right: 20px;
    &:hover{
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0,0.1);
    }
    .add-icon{
      padding: 18px 20px;
      font-size: 20px;
    }
    .add-txt{
      padding: 0 20px 5px 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: bold;
    }
  }
  .project-model{
    background-position: top;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    .txt{
      width: 100%;
      height: 40px;
      background: #ffffff;
      position: absolute;
      bottom: 0;
      left: 0;
      line-height: 40px;
      padding: 0 10px;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .btn{
      width: 100%;
      height: 100%;
      position: absolute;
      display: none;
      top: 0;
      left: 0;
      background: rgba(0,0,0,0.6);
      line-height: 100px;
      text-align: center;
    }
    &:hover{
      .btn{
        display: block;
      }
    }
  }
}
.task-main{
  width: 100%;
  position: relative;
  overflow: auto;
  background: #f5f7fa;
  .task-box{
    position: relative;
    box-sizing: border-box;
    padding: 10px 0;
    &:after{
      display: table;
      content: "";
      clear: both;
    }
    &:before{
      display: table;
      content: "";
    }
    .task-level{
      width: 220px;
      float: left;
      box-sizing: border-box;
      padding: 0 10px;
    }
    .add-task{
      width: 200px;
      height: 40px;
      line-height: 40px;
      position: relative;
      background-color: #fff;
      border-radius: 4px;
      border: 1px dashed #ebebeb;
      text-align: center;
      font-size: 12px;
      cursor: pointer;
      &:hover{
        color: #409EFF;
        border: 1px dashed #409EFF;
      }
    }
    .task{
      width: 200px;
      position: relative;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #ebebeb;
      margin-bottom: 10px;
      cursor: pointer;
      &:hover{
        box-shadow: 0 2px 12px 0 rgba(64, 158, 255,0.6);
      }
      .task-header{
        width: 100%;
        height: 40px;
        line-height: 40px;
        position: relative;
        padding: 0 50px 0 30px;
        overflow: hidden;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
        .xh{
          width: 16px;
          height: 16px;
          background: #409EFF;
          position: absolute;
          color: #fff;
          line-height: 16px;
          border-radius: 50%;
          font-weight: bold;
          font-size: 11px;
          top: 12px;
          left: 10px;
          text-align: center;
        }
        span{
          font-weight: bold;
        }
        .edit{
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          position: absolute;
          right: 35px;
          top: 10px;
          border-radius: 20px;
          cursor: pointer;
          font-size: 12px;
          &:hover{
            background: #409EFF;
            color: #ffffff;
          }
        }
        .close{
          width: 20px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          position: absolute;
          right: 10px;
          top: 10px;
          border-radius: 20px;
          cursor: pointer;
          font-size: 12px;
          &:hover{
            background: #F56C6C;
            color: #ffffff;
          }
        }
      }
      .task-foot{
        padding: 0 10px 10px 10px;
        font-size: 12px;
        border-top: 1px solid #ebebeb;
        &:after{
          display: table;
          content: "";
          clear: both;
        }
        .tit{
          float: left;
          height: 28px;
          padding-top: 4px;
        }
        .c{
          float: left;
          width: 16px;
          height: 16px;
          text-align: center;
          line-height: 16px;
          border-radius: 50%;
          background: #67C23A;
          color: #fff;
          font-weight: bold;
          font-size: 11px;
          margin-top: 12px;
          margin-right: 10px;
          &:last-child{
            margin-right: 0;
          }
        }
      }
    }
    .task-green{
      box-shadow: 0 2px 12px 0 rgba(103, 194, 58,0.6);
    }
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  margin-right: 10px;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
  margin-right: 10px;
}
</style>
